<template>
  <Nav />
  <div class="home-container">
    <div class="message">
      <h1 class="welcome-message poppins-light">
        ALCANCE A
        <span class="poppins-semibold">NOTA MÁXIMA</span>
        NO RANKING
        <span class="poppins-semibold">SICONFI</span>
      </h1>
      <h3 class="welcome-message-2 poppins-light">
        O Ranking SICONFI avalia a qualidade da informação contábil e fiscal dos
        municípios. Alcançar uma boa classificação neste ranking é essencial
        para garantir uma gestão pública eficiente e transparente, evitando
        penalidades fiscais e atraindo mais recursos para o município.
      </h3>
    </div>
    <div class="siconfi-nota">
      <h4 class="poppins-light nota-municipio">
        Com
        <span class="poppins-semibold"> Falcon RANK, {{ cidade }} </span>
        pode alcançar
      </h4>
      <img
        class="img-fluid img-size-control"
        width="380"
        src="@/assets/siconfi-nota.png"
        alt="SICONFI Nota"
      />
    </div>
  </div>
  <Footer />
</template>

<script>
import Nav from "@/components/Nav.vue";
import { mapActions, mapState } from "vuex";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  computed: {
    ...mapState(["cidade", "userEntidade"]),
  },
  data() {
    return {
      nomeMunicipio: "",
    };
  },
  async created() {
    try {
      await this.validateToken();
      this.checkUserEntidade();
    } catch (error) {
      console.log(error);
      
      // Handle specific case of deleted users
      if (error.message === "USER_DELETED") {
        // Show a toast notification about the deleted account
        this.$store.dispatch("showToast", {
          type: "error",
          message: "Sua conta foi removida ou desativada. Redirecionando para o login...",
        });
        
        // Delay redirect to allow user to see the message
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      } else {
        // For other authentication errors, redirect immediately
        this.$router.push("/login");
      }
    }
  },
  methods: {
    ...mapActions(["validateToken"]),
    checkUserEntidade() {
      if (!this.userEntidade) {
        this.$router.push("/selecaoEntidades");
      }
    },
  },
  components: {
    Nav,
    Footer
  },
};
</script>

<style>
.home-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh; /* Adjust the height as needed */
  padding: 0 20px;
}

.message {
  flex: 1;
  text-align: left;
  margin-left: 200px;
}

.siconfi-nota {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  margin-right: 200px;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.welcome-message {
  font-size: 2rem;
  color: var(--azul-final);
  margin-bottom: 30px;
}

.welcome-message-2 {
  font-size: 1.5rem;
  color: var(--azul-final);
}

.municipio {
  font-size: 1.3rem;
  color: var(--azul-final);
  position: absolute;
  text-align: center;
  top: 50%;
  left: 34%;
  transform: translate(-50%, -50%);
  height: 80px;
  width: 185px;
  display: flex;
  justify-content: center;
  align-items: center;
}

h4.nota-municipio {
  /* margin-left: -20px; */
  text-align: center;
}
</style>
